import React, { useEffect } from "react";
import {
    useParams,
} from "react-router-dom";

import { LazyLoadImage } from 'react-lazy-load-image-component';
import HeaderImage from "../../../../assets/CitasServicio/images/header@2x.png"

import ReactLoading from 'react-loading';

import {
    cancelarCita as deleteCita,
    sendMailDealerCancelar,
    getConcesionarios
} from "../../../../API/CitasServicioRequest"

import ImagenCancel from "../../../../assets/CitasServicio/images/cancel-image.png"

const CancelarCitaServicio = () => {
    const { idcita, idconcesionaria, uuid, correo, cliente } = useParams();
    const [loadingCancel, setLoadingCancel] = React.useState(false);
    const [errorCancelar, setErrorCancelar] = React.useState(false);
    const [correoContacto, setCorreoContacto] = React.useState(false);
    const [successCancelar, setSuccessCancelar] = React.useState(false);

    const findConcesionarios = async () => {
        let correoEncontrado = []

        try {
            const responseConcesionarios = await getConcesionarios();

            const dealer = responseConcesionarios.data.data.filter(function (el) {
                return el.dealerNumber === parseInt(idconcesionaria)
            })[0];

            if (dealer.contactos !== null) {
                correoEncontrado = dealer.contactos.split(",").length > 8 ? dealer.contactos.split(",")[8].split(";").map(item => item.trim()) : "";

                console.log(correoEncontrado)

            }

        } catch (error) {
            console.error(error)
        } finally{
            setCorreoContacto(correoEncontrado)
        }
    }

    useEffect(() => {
        findConcesionarios()
        // eslint-disable-next-line
    }, [])

    const cancelarCita = () => {
        const stateData = {
            cliente,
            correo,
            uuid,
            idcita,
            idconcesionaria,
            correoContacto
        }

        setLoadingCancel(true);

        deleteCita(uuid, idcita, idconcesionaria)
            .then((response) => {
                //console.log(response);

                if (response.data.data === null
                    || (response.data.data.hasOwnProperty('message') && response.data.data.message === "Endpoint request time out")
                    || (response.data.data.hasOwnProperty('errorCode') && response.data.data.hasOwnProperty('title'))) {
                    setLoadingCancel(false);
                    setErrorCancelar(true);
                    sendMailDealerCancelar(stateData)
                } else {
                    setLoadingCancel(false);
                    setErrorCancelar(false);
                    setSuccessCancelar(true);
                }
            })
            .catch((errorMessageGetMantenimiento) => {
                console.log(errorMessageGetMantenimiento)
                setLoadingCancel(false);
                setErrorCancelar(true);
                sendMailDealerCancelar(stateData)
            });
    }

    return (
        <>
            <div className="nm-wrapper-content mt-4">
                <div className="nm-area-content">
                    <div className="stage stage-headline">
                        <div className="nm-module-stage-headline" data-module="stage-headline">
                            <div className="nm-headline-container">
                                <h1 className="audi-headline-order-2 nm-headline">Cita de Servicio</h1>
                            </div>
                        </div>
                    </div>
                    <div id="nm-id-stage" className="nm-stage-wrapper">
                        <div className="nm-stage-elements">
                            <div className="nm-bs">
                                <ul className="nm-stage-list-special nm-bs-selected" data-module="stage-image">
                                    <li className="nm-stage-item" data-view-name="special_content1" id="special_content1-tpl">
                                        <div className="nm-stage nm-stage-has-mobileimg" data-view-name="special_content1" data-view-category="special">
                                            <div className="nm-stage-media">
                                                <LazyLoadImage
                                                    alt="citas_servicio_ty"
                                                    className="nm-stage-img"
                                                    src={HeaderImage}
                                                />
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                            <div className="nm-stage-container">
                                <div className="nm-stage nm-stage-has-mobileimg" data-view-name="special_content1" data-view-category="special">
                                    <div className="nm-stage-media">
                                        <LazyLoadImage
                                            alt="citas_servicio_ty"
                                            className="nm-stage-img"
                                            src={HeaderImage}
                                        />
                                    </div>
                                    <div className="nm-stage-subcontainer">
                                        <div className="nm-stage-buttons">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="container citas-servicio">
                <div className="row mb-5">
                    <div className="col-12 col-md-6 text-center mt-5 cs-panel-image">
                        <LazyLoadImage
                            alt="citas_servicio_ty"
                            className="w-100"
                            src={ImagenCancel}
                        />
                    </div>

                    {
                        !loadingCancel
                            ?
                            !successCancelar
                                ? <div className="col-12 col-md-6 ps-2 ps-md-4 mt-5 mb-4 mobile-center d-vertical-center">
                                    <div className="d-block">
                                        <div className="col-12 text-left">
                                            <h2 className="mb-4">
                                                {
                                                    !errorCancelar
                                                        ? "¿Seguro que deseas cancelar tu cita de servicio?" : "No pudimos cancelar tu cita :("
                                                }
                                            </h2>
                                            <p>
                                                {
                                                    errorCancelar && "¿Deseas volver a intentarlo? "
                                                }
                                                Tu cita de servicio con número <b>{idcita}</b> será cancelada.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                : <div className="col-12 col-md-6 ps-2 ps-md-4 mt-5 mb-4 mobile-center d-vertical-center">
                                    <div className="d-block">
                                        <h2 className="mb-4">
                                            Tu cita ha sido cancelada
                                        </h2>
                                        <p>
                                            Tu cita de servicio con número <b>{idcita}</b> se ha cancelado.<br />
                                            Gracias por tu interés.
                                        </p>
                                    </div>
                                </div>
                            : <div className="col-12 col-md-6 ps-2 ps-md-4 mt-5 text-center mobile-center d-vertical-center">
                                <div className="loading-g d-vertical-center">
                                    <div>
                                        <ReactLoading type="cylon" color="#000" width={'100%'} />
                                        <span>Cancelando</span>
                                    </div>
                                </div>
                            </div>
                    }

                    {
                        !loadingCancel && !successCancelar &&
                        <div className="col-12 mt-5 mb-5 text-center">
                            <button
                                className="button-enviar"
                                onClick={() => cancelarCita()}
                            >
                                Cancelar Cita
                            </button>
                        </div>
                    }
                </div>
            </div>
        </>
    );
};

export default CancelarCitaServicio;